import { useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import MKButton from "components/MKButton";
import borders from "assets/theme/base/borders";
import { Box } from "@mui/material";
import Iconify from "components/iconify";
import CartoonCard from "./CartoonCard";

export default function CartoonCardBasic({
  title,
  description,
  buttons,
  color = "#ff4e50",
  secondaryColor = "#f9d423",
  tilt = false, // Default: No tilt
  baseTileAngle = -2, // Starting tilt angle
  endTiltAngle = 3, // Ending tilt angle
  children,
  image,
}) {

  return (
    <CartoonCard
      color={color}
      secondaryColor={secondaryColor}
      tilt={tilt}
      baseTileAngle={baseTileAngle}
      endTiltAngle={endTiltAngle}
    >
      {/* Title */}
      <MKTypography
        variant="h2"
        color="white"
        fontWeight="bold"
        sx={{
          textShadow: "2px 2px black",
          letterSpacing: "2px",
          whiteSpace: "pre-line",
          mb: 2,
        }}
      >
        {title}
      </MKTypography>

      {/* Description */}
      <MKTypography
        variant="body1"
        color="white"
        mt={1}
        sx={{
          fontSize: "18px",
          fontWeight: "bold",
          textShadow: "1px 1px black",
          letterSpacing: "2px",
        }}
      >
        {description}
      </MKTypography>

      {/* Custom Children */}
      {children && <div style={{ marginTop: "16px" }}>{children}</div>}

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="center" mt={3}>
        {buttons?.map((button, index) => (
          <Grid item key={index}>
            <MKButton
              variant="contained"
              color={button.color}
              href={button.href}
              disabled={button.disabled}
              startIcon={<Iconify icon={button.icon} width={24} height={24} />}
              onClick={button.onClick ? button.onClick : null}
            >
              {button.label}
            </MKButton>
          </Grid>
        ))}
      </Grid>

      {/* Image */}
      {image && (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <img src={image} alt="Mascot" width="100" />
        </Box>
      )}
    </CartoonCard>
  );
}

// Default Props
CartoonCardBasic.defaultProps = {
  tilt: false,
  tiltAngle: 3,
  color: "#ff4e50",
};

// Prop Type Checking
CartoonCardBasic.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttons: PropTypes.array,
  color: PropTypes.string,
  tilt: PropTypes.bool,
  tiltAngle: PropTypes.number,
  children: PropTypes.node,
  image: PropTypes.string,
};
